<template>
  <div class="thumbnail-view">
    <div v-if="hasThumbnailSrc">
      <img :src="imgSrc" class="image" :width="width" :height="height" />
    </div>
    <div v-else class="flex items-center">
      <document-icon svgClasses="h-12 w-12" :type="icon"></document-icon>
    </div>
  </div>
</template>

<script>
import { DOCUMENT_KIND } from "@/config/const";
import { ColorMixin, DocumentMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";
import DocumentIcon from "../../icon/DocumentIcon";
import moment from "moment-timezone";

const {
  mapActions: mapActionsOfenterpriseDocumentManager,
} = createNamespacedHelpers("enterpriseDocumentManager");

const INTERVAL_TIMER_MILLISECONDS = 30 * 1000;
const EXPIRED_TIME_MINUTES = 5;


//以下のContentTypeの場合、サムネイルファイルはjpegファイルとなる。
const CONVERT_TYPE_LIST = ["image/tiff"];

export default {
  mixins: [ColorMixin, DocumentMixin],
  components: { DocumentIcon },
  props: {
    document:
    {
      required: true,
      type: Object,
      default: () => {
        return {
          name: null,
          type: null,
        }
      }
    },
    isFolder: Boolean,
    width: Number,
    height: Number
  },
  data () {
    return {
      imgSrc: null,
      hasThumbnailSrc: false,
      getThumbnailTimer: null,
    }
  },
  watch: {
    document: {
      handler: async function (_) {
        await this.getThumbnail();
      },
      deep: true
    },
  },
  computed: {
    icon () {
      if (this.isFolder) return DOCUMENT_KIND.FOLDER
      return this.documentType
    },

    documentType () {
      return this.getDocumentMimeKind(this.document.type);
    },

    isExpiredTime () {
      // 最終更新時間から5分以上経っている場合はサムネイルの再取得を行わない
      return moment().diff(this.document.updated, "minutes") > EXPIRED_TIME_MINUTES;
    },

    showThumbnail () {
      return this.documentType === DOCUMENT_KIND.IMAGE || this.documentType === DOCUMENT_KIND.PDF;
    },

    thumbnailPath () {
      if (!this.showThumbnail) return;

      const path = this.document.path.replace(this.document.name, `.thumbs/${this.document.name}`);

      switch (this.documentType) {
        case DOCUMENT_KIND.IMAGE:
          return this.setImageFileExt(path);
        case DOCUMENT_KIND.PDF:
          return this.setExtPng(path);
        default:
          return;
      }
    }

  },
  methods: {
    ...mapActionsOfenterpriseDocumentManager([
      "getFileUrl",
    ]),

    setExtPng (name) {
      return `${name.substr(0, name.lastIndexOf("."))}.png`;
    },

    setExtJpeg (name) {
      return `${name.substr(0, name.lastIndexOf("."))}.jpeg`;
    },

    setImageFileExt(path) {
      if(CONVERT_TYPE_LIST.find(type => type === this.document.type)) {
        return this.setExtJpeg(path);
      }
      return path;
    },

    async getThumbnail () {

      const url = await this.getFileUrl(this.thumbnailPath);
      if (!url) {
        this.hasThumbnailSrc = false;
        this.setTimer();
        return;
      }

      this.imgSrc = url;
      this.hasThumbnailSrc = true;
      this.removeTimer();
    },

    setTimer () {
      //最終更新時間から5分以上経過している場合、タイマーを設定せず削除する
      if (this.isExpiredTime) {
        this.removeTimer();
        return;
      };

      // すでにタイマーが存在する場合は設定しない
      if(this.getThumbnailTimer) return;

      this.getThumbnailTimer = setInterval(this.getThumbnail, INTERVAL_TIMER_MILLISECONDS);
    },

    removeTimer () {
      clearInterval(this.getThumbnailTimer);
      this.getThumbnailTimer = null;
    },

    async initThumbnail () {
      await this.getThumbnail();
    },
  },

  async mounted () {
    if (this.showThumbnail) {
      this.initThumbnail();
    }
  },
  beforeDestroy () {
    this.imgSrc = null;
    this.hasThumbnailSrc = false;
    clearInterval(this.getThumbnailTimer);
    this.getThumbnailTimer = null;
  },
}
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";
@import "src/assets/scss/vuexy/variables";

.thumbnail-view {
  .image {
    width: auto;
    background-color: transparent;
  }
  .icon {
    padding: 8px;
    color: $aisea-mouse-gray;
  }
}
</style>